<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
        <!-- <a-select class="waterQualitySelect" style="margin-left:100px" v-model="waterQualityMeterId" placeholder="请选择设备"
          @change="queryWaterQualityMinuteRecord">
          <a-select-option v-for="data in dataSource" :key="data.id" :value="data.meterId">
            {{data.deviceName}}
          </a-select-option>
        </a-select> -->
      </div>
    </div>
    <div class="tabs">
      <div class="tab" v-for="(item,index) in tabList" :key="item.key" :class="tabKey == item.key?'tab-active': ''"
        @click="handleChange(item,index)">
        <label class="tab-title">{{item.title}}</label>
      </div>
    </div>
    <div class="m-panel-body">
      <Echart ref="option" :options="option" style="height: calc(100% - 26px);"></Echart>
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction,
    getAction
  } from '@/api/manage'
  import {
    randomNumber
  } from '@/utils/util'
  import * as dayjs from 'dayjs';
  import {
    isUndefinedAndNull
  } from '@/utils/validate';
  export default {
    props: {
      titleImage: {
        type: String,
        default: ''
      },
    },
    data() {
      return {
        title: this.$t('今日水质指标分析'),
        option: {},
        // tabList: [
        // {title: '酸碱度', key: 1},
        // {title: '温度', key: 2},
        // {title: '浊度', key: 3},
        // {title: '余氯', key: 4},
        // {title: '溶解氧', key: 5},
        // {title: '氧化还原', key: 6},
        // {title: '电导率', key: 7},
        // {title: '氨氮', key: 8},
        // {title: '化学耗氧量', key: 9},
        // ],
        tabList: [{
            key: 'w01001',
            title: this.$t('PH值')
          },
          {
            key: 'w01002',
            title: this.$t('色度')
          },
          {
            key: 'w01003',
            title: this.$t('浑浊度')
          },
          //{key: 'w01006',title:'溶解性总固体'},
          {
            key: 'w10000',
            title: this.$t('硬度')
          },
          {
            key: 'w10001',
            title: this.$t('氧化还原')
          },
          {
            key: 'w21022',
            title: this.$t('氯化物')
          },
          //{key: 'w21038',title:'硫酸盐'},
          //{key: 'w01019',title:'高锰酸盐'},
          {
            key: 'w01010',
            title: this.$t('温度值')
          },
          {
            key: 'w21024',
            title: this.$t('余氯')
          },
          {
            key: 'w01014',
            title: this.$t('电导率')
          }
        ],
        tabKey: 'w01001',
        heightValue: 0,
        lowValue: 0,
        data: [],
        url: {
          FlowLineStatistical: "/jeecg-charge/wq/wQDataRecord/queryFlowLineStatistical",
          //list: "/part/partWaterQualityMinuteRecord/analysisList",
          list: '/jeecg-charge/part/partWaterQualityMinuteRecord/analysisByDateList',
          waterQualityDeviceList: "/jeecg-charge/part/partWaterQualityLastRecord/list"
        },
        FlowLineStatistical: [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          []
        ],
        standard: [],
        dataSource: [],
        minuteRecod: [],
        waterQualityMeterId: '',
        waterQualityMeter: {}
      }
    },
    mounted() {},
    methods: {
      init() {
        this.resetData()
        this.queryWaterQualityDevice()
        //this.queryFlowLineStatistical()
        // 为了演示，暂时注释掉实时请求，写成假数据
        // let date = ['00:10',"00:20","00:30","00:40","00:50","01:00",'01:10',"01:20","01:30","01:40","01:50","02:00",
        //     '02:10',"02:20","02:30","02:40","02:50","03:00",'03:10',"03:20","03:30","03:40","03:50","03:00",
        //     '04:10',"04:20","04:30","04:40","04:50","05:00",'05:10',"05:20","05:30","05:40","05:50","05:00",
        //     '05:10',"05:20","05:30","05:40","05:50","06:00",'06:10',"06:20","06:30","06:40","06:50","06:00",
        //     '06:10',"06:20","06:30","06:40","06:50","07:00",'07:10',"07:20","07:30","07:40","07:50","08:00",
        //     '08:10',"08:20","08:30","08:40","08:50","09:00",'09:10',"09:20","09:30","09:40","09:50","10:00",
        //     '10:10',"10:20","10:30","10:40","10:50","11:00",'11:10',"11:20","11:30","11:40","11:50","12:00",
        //     '12:10',"12:20","12:30","12:40","12:50","12:00",'12:10',"12:20","12:30","12:40","12:50","13:00",
        //     ]
        // for(let i = 0;i<96;i++) {
        //     this.FlowLineStatistical[1].push((randomNumber(7500,7800)/1000).toFixed(3))
        //     this.FlowLineStatistical[2].push((randomNumber(170000,200000)/10000).toFixed(4))
        //     this.FlowLineStatistical[3].push((randomNumber(26000,28000)/10000).toFixed(4))
        //     this.FlowLineStatistical[4].push((randomNumber(2000,2500)/10000).toFixed(3))
        //     this.FlowLineStatistical[5].push((randomNumber(7500,8000)/10000).toFixed(4))
        //     this.FlowLineStatistical[6].push((randomNumber(60,80)/1000).toFixed(2))
        //     this.FlowLineStatistical[7].push((randomNumber(2600,2800)/10000).toFixed(4))
        //     this.FlowLineStatistical[8].push((randomNumber(10,15)/100).toFixed(1))
        //     this.FlowLineStatistical[9].push((randomNumber(10,15)/100).toFixed(1))
        // }
        // let standard = ["{\"ph_up\":8,\"ph_down\":6,\"ss_up\":3,\"ss_down\":2,\"doo_up\":0.8,\"doo_down\":0.6,\"ec_up\":0.3,\"ec_down\":0.2,\"temp_up\":40,\"temp_down\":5,\"fcl_up\":0.3,\"fcl_down\":0.1,\"chemo_up\":0.2,\"chemo_down\":0,\"nh3n_up\":0.2,\"nh3n_down\":0,\"orp_up\":0.1,\"orp_down\":0}"]
        // this.FlowLineStatistical[0]=date
        // this.FlowLineStatistical[10]=standard
        // this.standard = JSON.parse(this.FlowLineStatistical[10][0])
        // this.setOption(1)
        //this.standard = ["{\"ph_up\": }"]
      },
      resetData() {
        if (JSON.stringify(this.option) !== '{}') {
          this.$refs.option.clear();
          this.option = this.$options.data.call(this).option
        }
        this.tabKey = this.$options.data.call(this).tabKey
      },
      handleChange(item, index) {
        this.tabKey = item.key
        //this.setOption(this.tabKey,index)
        this.option = {}
        this.queryWaterQualityMinuteRecord(index)
      },
      queryFlowLineStatistical() {
        let params = {}
        postAction(this.url.FlowLineStatistical, params).then((res) => {
          if (res.success) {
            this.FlowLineStatistical = res.result;
            this.standard = JSON.parse(this.FlowLineStatistical[10][0])
            this.setOption(1)
          }
        })
      },
      queryWaterQualityDevice() {
        let params = {};
        // getAction(this.url.waterQualityDeviceList, params).then((res) => {
        //   if (res.success) {
        //     let dataSource = res.result.records;
        //     this.dataSource  = dataSource;
        //     this.waterQualityMeterId = this.dataSource[0].meterId;
        //     this.queryWaterQualityMinuteRecord(0);
        //   }else{
            
        //   }
        //   if (res.code === 510) {
        //     this.$message.warning(res.message)
        //   }
        // })
        this.dataSource = [{
            "deviceType": "WaterQuality",
            "w01001-Rtd": "6.033",
            "IMEI-Flag": "N",
            "updateTime": "2024-04-02 18:43:47",
            "remark": null,
            "w01001-Flag": "N",
            "DataTime": "20240402184340",
            "deviceName": "水厂末梢水水质",
            "w01003-Flag": "N",
            "w01014-Flag": "N",
            "createBy": "system",
            "IMEI-Rtd": "861241058573047",
            "createTime": "2023-09-11 16:12:23",
            "updateBy": "system",
            "w21024-Flag": "N",
            "meterId": "230911XF02",
            "w01010-Rtd": "42.167",
            "sysTime": "2024-04-02 18:43:47",
            "w01010-Flag": "N",
            "w01003-Rtd": "0.026",
            "id": "8ddc948f-4272-44cc-b25a-8e940dd991fd",
            "w21024-Rtd": "0.1",
            "w01014-Rtd": "645.026",
            "deviceLocation": "哈尔莫顿镇末梢水"
          },
          {
            "deviceType": "WaterQuality",
            "w01001-Rtd": "8.01",
            "updateTime": "2024-04-02 18:42:28",
            "remark": null,
            "DataTime": "20240402184227",
            "deviceName": "水厂末梢水水质",
            "createBy": "system",
            "createTime": "2023-06-21 11:00:29",
            "updateBy": "system",
            "meterId": "864452065057976",
            "w01010-Rtd": "15.80",
            "sysTime": "2024-04-02 18:42:28",
            "w01003-Rtd": "0.030",
            "id": "2e4c799a-c084-4fbe-a07e-058651388770",
            "w21024-Rtd": "0.119",
            "deviceLocation": "和静镇水厂末梢水"
          },
          {
            "deviceType": "WaterQuality",
            "w01001-Rtd": "7.794",
            "IMEI-Flag": "N",
            "updateTime": "2024-04-02 18:41:16",
            "remark": null,
            "w01001-Flag": "N",
            "DataTime": "20240402184100",
            "deviceName": "水厂末梢水水质",
            "w01003-Flag": "N",
            "w01014-Flag": "N",
            "createBy": "system",
            "IMEI-Rtd": "861241058528314",
            "createTime": "2023-09-11 16:09:35",
            "updateBy": "system",
            "w21024-Flag": "N",
            "meterId": "230911XF01",
            "w01010-Rtd": "13.376",
            "sysTime": "2024-04-02 18:41:16",
            "w01010-Flag": "N",
            "w01003-Rtd": "0.116",
            "id": "91c19779-2533-451a-80b9-99fc638cdc3e",
            "w21024-Rtd": "0.1",
            "w01014-Rtd": "401.091",
            "deviceLocation": "巴润哈尔莫敦镇末梢水"
          },
          {
            "deviceType": "WaterQuality",
            "w01001-Rtd": "6.67",
            "updateTime": "2024-04-02 18:40:56",
            "remark": null,
            "w01024-Flag": "N",
            "DataTime": "20240402184000",
            "w01001-Flag": "N",
            "deviceName": "出厂水水质检测",
            "w01003-Flag": "N",
            "w01024-Rtd": "0.001",
            "w01014-Flag": "N",
            "createBy": "system",
            "createTime": "2023-11-03 13:29:28",
            "updateBy": "system",
            "w01024-SampleTime": "20240402183912",
            "meterId": "20230829001348",
            "w01010-Rtd": "23.1",
            "sysTime": "2024-04-02 18:40:56",
            "w01010-Flag": "N",
            "w01003-Rtd": "0.34",
            "id": "f9f6c26f-be95-4661-9ada-ef98fac6461d",
            "w01014-Rtd": "297.9",
            "deviceLocation": "哈尔莫敦镇水厂出厂水"
          },
          {
            "deviceType": "WaterQuality",
            "w01001-Rtd": "7.16",
            "updateTime": "2024-04-02 18:00:56",
            "remark": null,
            "DataTime": "20240402180000",
            "w01001-Flag": "N",
            "deviceName": "出厂水水质检测",
            "w01003-Flag": "N",
            "w01014-Flag": "N",
            "createBy": "system",
            "createTime": "2023-12-06 20:00:28",
            "updateBy": "system",
            "meterId": "20230829001349",
            "w01010-Rtd": "14.8",
            "sysTime": "2024-04-02 18:00:56",
            "w01010-Flag": "N",
            "w01003-Rtd": "0.340",
            "id": "195bc0e9-68ed-44c8-9e42-5694bc7b195b",
            "w01014-Rtd": "365.438",
            "deviceLocation": "巴润哈尔莫敦镇水厂出厂水"
          },
          {
            "deviceType": "WaterQuality",
            "w01001-Rtd": "7.505",
            "w01006-Rtd": "191.806",
            "w01006-Flag": "N",
            "updateTime": "2024-04-02 18:00:01",
            "remark": null,
            "w01001-Flag": "N",
            "DataTime": "20240402180000",
            "deviceName": "出厂水水质检测",
            "w01003-Flag": "N",
            "w01014-Flag": "N",
            "createBy": "system",
            "createTime": "2023-12-07 16:23:38",
            "updateBy": "system",
            "w21024-Flag": "N",
            "meterId": "8888888HJZ0002",
            "sysTime": "2024-04-02 18:00:01",
            "w01003-Rtd": "0.281",
            "id": "4d267cba-a1d7-4ad3-b8ba-ff53b2fe5f4a",
            "w21024-Rtd": "0",
            "w01014-Rtd": "90.906",
            "deviceLocation": "乌拉斯台水厂出厂水"
          },
          {
            "w01002-Flag": "N",
            "w21022-Rtd": "3.395",
            "w10001-Rtd": "182.116",
            "w01001-Rtd": "7.793",
            "w10000-Flag": "N",
            "w01019-Rtd": "0.000",
            "remark": null,
            "DataTime": "20240402180000",
            "w10000-Rtd": "2.590",
            "deviceName": "出厂水水质检测",
            "w01019-Flag": "D",
            "w01002-Rtd": "1.584",
            "updateBy": "system",
            "sysTime": "2024-04-02 18:00:00",
            "id": "f5db033c-9e64-42fb-aaac-96bcd54d4f25",
            "deviceType": "WaterQuality",
            "w21022-Flag": "N",
            "w21038-Rtd": "0.000",
            "updateTime": "2024-04-02 18:00:00",
            "w01001-Flag": "N",
            "w01003-Flag": "N",
            "w10001-Flag": "N",
            "createBy": "system",
            "createTime": "2023-03-17 17:15:49",
            "w21024-Flag": "N",
            "meterId": "8888888HJZ0001",
            "w01003-Rtd": "0.293",
            "w21038-Flag": "D",
            "w21024-Rtd": "0.028",
            "deviceLocation": "和静镇水厂出厂水"
          }
        ];
        this.waterQualityMeter = this.dataSource[0];
        this.waterQualityMeterId = this.dataSource[0].meterId;
        this.queryWaterQualityMinuteRecord(0);
      },
      queryWaterQualityMinuteRecord(arg) {
        console.log(arg)
        if (this.dataSource.length < 1) {
          return;
        }
        let date = dayjs(new Date()).format("YYYY-MM-DD")
        //let date = '2023-04-09'
        var params = {
          deviceId: this.waterQualityMeterId,
          cmd: this.tabKey,
          beiginDate: date
        };
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            let dataSource = res.result;
            this.minuteRecod = dataSource;
            this.setOptionNew(arg);
          }else{
            if (arg == 0) { //PH值
              this.minuteRecod = {
                "maxArr": [
                  6.035,
                  6.035,
                  6.035,
                  6.035,
                  6.034,
                  6.035,
                  6.034,
                  6.035,
                  6.034,
                  6.034,
                  6.034,
                  6.035,
                  6.033,
                  6.034,
                  6.034,
                  6.034,
                  6.033,
                  6.034,
                  6.034,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.032,
                  6.032,
                  6.032,
                  6.032,
                  6.031,
                  6.032,
                  6.032,
                  6.031,
                  6.031,
                  6.031,
                  6.032,
                  6.031,
                  6.032,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.029,
                  6.03,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.03,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029
                ],
                "minArr": [
                  6.033,
                  6.035,
                  6.034,
                  6.035,
                  6.033,
                  6.035,
                  6.033,
                  6.033,
                  6.033,
                  6.034,
                  6.034,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.033,
                  6.034,
                  6.032,
                  6.033,
                  6.032,
                  6.033,
                  6.031,
                  6.033,
                  6.032,
                  6.032,
                  6.031,
                  6.032,
                  6.032,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.03,
                  6.029,
                  6.031,
                  6.03,
                  6.03,
                  6.029,
                  6.031,
                  6.031,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.029,
                  6.029,
                  6.03,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029
                ],
                "dateArr": [
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:30:00",
                  "2024-04-02 18:20:00",
                  "2024-04-02 18:10:00",
                  "2024-04-02 18:00:00",
                  "2024-04-02 17:50:00",
                  "2024-04-02 17:40:00",
                  "2024-04-02 17:30:00",
                  "2024-04-02 17:20:00",
                  "2024-04-02 17:10:00",
                  "2024-04-02 16:40:00",
                  "2024-04-02 16:20:00",
                  "2024-04-02 16:00:00",
                  "2024-04-02 15:50:00",
                  "2024-04-02 15:40:00",
                  "2024-04-02 15:30:00",
                  "2024-04-02 15:10:00",
                  "2024-04-02 15:00:00",
                  "2024-04-02 14:50:00",
                  "2024-04-02 14:40:00",
                  "2024-04-02 14:30:00",
                  "2024-04-02 14:20:00",
                  "2024-04-02 14:10:00",
                  "2024-04-02 14:00:00",
                  "2024-04-02 13:50:00",
                  "2024-04-02 13:40:00",
                  "2024-04-02 13:30:00",
                  "2024-04-02 13:20:00",
                  "2024-04-02 13:10:00",
                  "2024-04-02 13:00:00",
                  "2024-04-02 12:50:00",
                  "2024-04-02 12:40:00",
                  "2024-04-02 12:20:00",
                  "2024-04-02 12:10:00",
                  "2024-04-02 12:00:00",
                  "2024-04-02 11:50:00",
                  "2024-04-02 11:30:00",
                  "2024-04-02 11:20:00",
                  "2024-04-02 10:50:00",
                  "2024-04-02 10:40:00",
                  "2024-04-02 10:30:00",
                  "2024-04-02 10:20:00",
                  "2024-04-02 10:10:00",
                  "2024-04-02 10:00:00",
                  "2024-04-02 09:40:00",
                  "2024-04-02 09:30:00",
                  "2024-04-02 09:20:00",
                  "2024-04-02 09:10:00",
                  "2024-04-02 09:00:00",
                  "2024-04-02 08:50:00",
                  "2024-04-02 08:40:00",
                  "2024-04-02 08:30:00",
                  "2024-04-02 08:10:00",
                  "2024-04-02 08:00:00",
                  "2024-04-02 07:50:00",
                  "2024-04-02 07:40:00",
                  "2024-04-02 07:30:00",
                  "2024-04-02 07:20:00",
                  "2024-04-02 07:10:00",
                  "2024-04-02 07:00:00",
                  "2024-04-02 06:50:00",
                  "2024-04-02 06:40:00",
                  "2024-04-02 06:30:00",
                  "2024-04-02 06:20:00",
                  "2024-04-02 06:10:00",
                  "2024-04-02 06:00:00",
                  "2024-04-02 05:50:00",
                  "2024-04-02 05:40:00",
                  "2024-04-02 05:30:00",
                  "2024-04-02 05:20:00",
                  "2024-04-02 05:10:00",
                  "2024-04-02 05:00:00",
                  "2024-04-02 04:50:00",
                  "2024-04-02 04:40:00",
                  "2024-04-02 04:30:00",
                  "2024-04-02 04:20:00",
                  "2024-04-02 04:10:00",
                  "2024-04-02 04:00:00",
                  "2024-04-02 03:50:00",
                  "2024-04-02 03:40:00",
                  "2024-04-02 03:30:00",
                  "2024-04-02 03:20:00",
                  "2024-04-02 03:10:00",
                  "2024-04-02 03:00:00",
                  "2024-04-02 02:50:00",
                  "2024-04-02 02:40:00",
                  "2024-04-02 02:30:00",
                  "2024-04-02 02:20:00",
                  "2024-04-02 02:10:00",
                  "2024-04-02 02:00:00",
                  "2024-04-02 01:50:00",
                  "2024-04-02 01:40:00",
                  "2024-04-02 01:30:00",
                  "2024-04-02 01:00:00",
                  "2024-04-02 00:50:00",
                  "2024-04-02 00:40:00",
                  "2024-04-02 00:30:00",
                  "2024-04-02 00:20:00",
                  "2024-04-02 00:10:00",
                  "2024-04-02 00:00:00"
                ],
                "rtdArr": [],
                "avgArr": [
                  6.034,
                  6.035,
                  6.034,
                  6.035,
                  6.034,
                  6.035,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.033,
                  6.034,
                  6.034,
                  6.034,
                  6.033,
                  6.034,
                  6.034,
                  6.033,
                  6.033,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.034,
                  6.033,
                  6.033,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.034,
                  6.033,
                  6.033,
                  6.032,
                  6.033,
                  6.032,
                  6.033,
                  6.032,
                  6.032,
                  6.032,
                  6.032,
                  6.032,
                  6.031,
                  6.032,
                  6.032,
                  6.031,
                  6.031,
                  6.031,
                  6.032,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.031,
                  6.031,
                  6.03,
                  6.031,
                  6.03,
                  6.031,
                  6.03,
                  6.03,
                  6.03,
                  6.031,
                  6.031,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.03,
                  6.029,
                  6.029,
                  6.03,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029,
                  6.029
                ],
                "deviceId": "230911XF02",
                "deviceName": "水厂末梢水水质",
                "deviceLocation": "哈尔莫顿镇末梢水"
              };
            } else if (arg == 2) { //浑浊度
              this.minuteRecod = {
                "maxArr": [
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.045,
                  0.047,
                  0.05,
                  0.056,
                  0.061,
                  0.06,
                  0.061,
                  0.057,
                  0.061,
                  0.061,
                  0.057,
                  0.059,
                  0.065,
                  0.067,
                  0.07,
                  0.069,
                  0.084,
                  0.089,
                  0.086,
                  0.095,
                  0.094,
                  0.118,
                  0.105,
                  0.108,
                  0.115,
                  0.107,
                  0.111,
                  0.112,
                  0.112,
                  0.112,
                  0.107,
                  0.106,
                  0.111,
                  0.113,
                  0.118,
                  0.115,
                  0.114,
                  0.12,
                  0.123,
                  0.122,
                  0.114,
                  0.108,
                  0.108,
                  0.116,
                  0.112,
                  0.137,
                  0.133,
                  0.133,
                  0.147,
                  0.149,
                  0.144,
                  0.138,
                  0.138,
                  0.137,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.149,
                  0.148,
                  0.15,
                  0.147,
                  0.15,
                  0.155,
                  0.154,
                  0.159,
                  0.153,
                  0.159,
                  0.161
                ],
                "minArr": [
                  0.026,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.046,
                  0.047,
                  0.052,
                  0.053,
                  0.056,
                  0.051,
                  0.053,
                  0.06,
                  0.056,
                  0.056,
                  0.057,
                  0.061,
                  0.063,
                  0.065,
                  0.065,
                  0.07,
                  0.088,
                  0.085,
                  0.093,
                  0.088,
                  0.103,
                  0.101,
                  0.106,
                  0.108,
                  0.101,
                  0.106,
                  0.108,
                  0.11,
                  0.103,
                  0.103,
                  0.103,
                  0.11,
                  0.111,
                  0.118,
                  0.108,
                  0.113,
                  0.115,
                  0.12,
                  0.113,
                  0.11,
                  0.106,
                  0.108,
                  0.11,
                  0.11,
                  0.135,
                  0.133,
                  0.13,
                  0.143,
                  0.143,
                  0.144,
                  0.137,
                  0.133,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.14,
                  0.148,
                  0.148,
                  0.144,
                  0.144,
                  0.153,
                  0.154,
                  0.159,
                  0.149,
                  0.153,
                  0.158
                ],
                "dateArr": [
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:30:00",
                  "2024-04-02 18:20:00",
                  "2024-04-02 18:10:00",
                  "2024-04-02 18:00:00",
                  "2024-04-02 17:50:00",
                  "2024-04-02 17:40:00",
                  "2024-04-02 17:30:00",
                  "2024-04-02 17:20:00",
                  "2024-04-02 17:10:00",
                  "2024-04-02 16:40:00",
                  "2024-04-02 16:20:00",
                  "2024-04-02 16:00:00",
                  "2024-04-02 15:50:00",
                  "2024-04-02 15:40:00",
                  "2024-04-02 15:30:00",
                  "2024-04-02 15:10:00",
                  "2024-04-02 15:00:00",
                  "2024-04-02 14:50:00",
                  "2024-04-02 14:40:00",
                  "2024-04-02 14:30:00",
                  "2024-04-02 14:20:00",
                  "2024-04-02 14:10:00",
                  "2024-04-02 14:00:00",
                  "2024-04-02 13:50:00",
                  "2024-04-02 13:40:00",
                  "2024-04-02 13:30:00",
                  "2024-04-02 13:20:00",
                  "2024-04-02 13:10:00",
                  "2024-04-02 13:00:00",
                  "2024-04-02 12:50:00",
                  "2024-04-02 12:40:00",
                  "2024-04-02 12:20:00",
                  "2024-04-02 12:10:00",
                  "2024-04-02 12:00:00",
                  "2024-04-02 11:50:00",
                  "2024-04-02 11:30:00",
                  "2024-04-02 11:20:00",
                  "2024-04-02 10:50:00",
                  "2024-04-02 10:40:00",
                  "2024-04-02 10:30:00",
                  "2024-04-02 10:20:00",
                  "2024-04-02 10:10:00",
                  "2024-04-02 10:00:00",
                  "2024-04-02 09:40:00",
                  "2024-04-02 09:30:00",
                  "2024-04-02 09:20:00",
                  "2024-04-02 09:10:00",
                  "2024-04-02 09:00:00",
                  "2024-04-02 08:50:00",
                  "2024-04-02 08:40:00",
                  "2024-04-02 08:30:00",
                  "2024-04-02 08:10:00",
                  "2024-04-02 08:00:00",
                  "2024-04-02 07:50:00",
                  "2024-04-02 07:40:00",
                  "2024-04-02 07:30:00",
                  "2024-04-02 07:20:00",
                  "2024-04-02 07:10:00",
                  "2024-04-02 07:00:00",
                  "2024-04-02 06:50:00",
                  "2024-04-02 06:40:00",
                  "2024-04-02 06:30:00",
                  "2024-04-02 06:20:00",
                  "2024-04-02 06:10:00",
                  "2024-04-02 06:00:00",
                  "2024-04-02 05:50:00",
                  "2024-04-02 05:40:00",
                  "2024-04-02 05:30:00",
                  "2024-04-02 05:20:00",
                  "2024-04-02 05:10:00",
                  "2024-04-02 05:00:00",
                  "2024-04-02 04:50:00",
                  "2024-04-02 04:40:00",
                  "2024-04-02 04:30:00",
                  "2024-04-02 04:20:00",
                  "2024-04-02 04:10:00",
                  "2024-04-02 04:00:00",
                  "2024-04-02 03:50:00",
                  "2024-04-02 03:40:00",
                  "2024-04-02 03:30:00",
                  "2024-04-02 03:20:00",
                  "2024-04-02 03:10:00",
                  "2024-04-02 03:00:00",
                  "2024-04-02 02:50:00",
                  "2024-04-02 02:40:00",
                  "2024-04-02 02:30:00",
                  "2024-04-02 02:20:00",
                  "2024-04-02 02:10:00",
                  "2024-04-02 02:00:00",
                  "2024-04-02 01:50:00",
                  "2024-04-02 01:40:00",
                  "2024-04-02 01:30:00",
                  "2024-04-02 01:00:00",
                  "2024-04-02 00:50:00",
                  "2024-04-02 00:40:00",
                  "2024-04-02 00:30:00",
                  "2024-04-02 00:20:00",
                  "2024-04-02 00:10:00",
                  "2024-04-02 00:00:00"
                ],
                "rtdArr": [],
                "avgArr": [
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.025,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.035,
                  0.047,
                  0.049,
                  0.054,
                  0.057,
                  0.058,
                  0.056,
                  0.055,
                  0.06,
                  0.058,
                  0.057,
                  0.058,
                  0.063,
                  0.065,
                  0.067,
                  0.067,
                  0.077,
                  0.089,
                  0.085,
                  0.094,
                  0.091,
                  0.11,
                  0.103,
                  0.107,
                  0.111,
                  0.104,
                  0.108,
                  0.11,
                  0.111,
                  0.108,
                  0.105,
                  0.105,
                  0.11,
                  0.112,
                  0.118,
                  0.112,
                  0.113,
                  0.118,
                  0.121,
                  0.118,
                  0.112,
                  0.107,
                  0.108,
                  0.113,
                  0.111,
                  0.136,
                  0.133,
                  0.131,
                  0.145,
                  0.146,
                  0.144,
                  0.138,
                  0.136,
                  0.081,
                  0.026,
                  0.026,
                  0.026,
                  0.026,
                  0.145,
                  0.148,
                  0.149,
                  0.146,
                  0.147,
                  0.154,
                  0.154,
                  0.159,
                  0.151,
                  0.156,
                  0.159
                ],
                "deviceId": "230911XF02",
                "deviceName": "水厂末梢水水质",
                "deviceLocation": "哈尔莫顿镇末梢水"
              };
            } else if (arg == 6) {
              this.minuteRecod = {
                "maxArr": [
                  38.595,
                  38.618,
                  38.61,
                  38.576,
                  38.678,
                  38.43,
                  38.678,
                  40.491,
                  40.781,
                  39.392,
                  39.748,
                  39.744,
                  39.852,
                  40.082,
                  40.219,
                  40.239,
                  40.002,
                  39.763,
                  40.131,
                  40.199,
                  40.195,
                  40.211,
                  40.163,
                  39.863,
                  39.798,
                  39.562,
                  39.162,
                  39.131,
                  39.12,
                  39.116,
                  39.096,
                  39.236,
                  39.022,
                  39.198,
                  39.065,
                  38.767,
                  37.902,
                  38.242,
                  39.994,
                  37.717,
                  37.761,
                  38.166,
                  37.539,
                  36.667,
                  38.23,
                  38.351,
                  39.442,
                  40.299,
                  40.522,
                  40.721,
                  40.467,
                  40.59,
                  40.042,
                  39.971,
                  39.971,
                  40.618,
                  39.979,
                  40.538,
                  40.57,
                  41.742,
                  42.589,
                  42.338,
                  38.853,
                  38.022,
                  36.896,
                  39.411,
                  39.531,
                  39.493,
                  38.328,
                  43.304,
                  37.586,
                  40.379,
                  38.7,
                  39.345,
                  41.024,
                  39.917,
                  39.863,
                  41.305,
                  40.698,
                  41.462,
                  37.938,
                  40.403,
                  42.402,
                  39.562,
                  40.793,
                  39.829,
                  39.848,
                  42.111,
                  40.534,
                  41.742,
                  40.809,
                  41.783,
                  39.131,
                  38.917,
                  40.042,
                  40.102,
                  40.65,
                  39.798,
                  40.447,
                  38.196
                ],
                "minArr": [
                  38.591,
                  38.4,
                  38.426,
                  38.396,
                  38.663,
                  38.219,
                  38.437,
                  38.486,
                  37.79,
                  37.717,
                  39.744,
                  37.053,
                  39.748,
                  40.078,
                  40.191,
                  40.211,
                  39.829,
                  39.694,
                  40.11,
                  40.187,
                  40.167,
                  40.203,
                  40.155,
                  39.848,
                  39.62,
                  39.477,
                  39.112,
                  39.127,
                  39.096,
                  39.081,
                  38.984,
                  39.112,
                  38.965,
                  38.861,
                  38.861,
                  38.708,
                  36.572,
                  37.342,
                  37.39,
                  37.605,
                  37.674,
                  37.985,
                  37.346,
                  36.537,
                  38.181,
                  38.317,
                  38.321,
                  39.763,
                  40.407,
                  40.65,
                  40.287,
                  40.495,
                  39.964,
                  39.944,
                  39.967,
                  39.937,
                  39.937,
                  39.956,
                  40.323,
                  39.94,
                  41.024,
                  41.041,
                  37.06,
                  37.927,
                  36.868,
                  39.003,
                  37.743,
                  38.483,
                  38.143,
                  39.524,
                  37.357,
                  37.793,
                  38.358,
                  38.621,
                  39.201,
                  39.89,
                  39.767,
                  39.605,
                  39.933,
                  40.439,
                  29.08,
                  38.079,
                  41.186,
                  38.441,
                  39.756,
                  39.531,
                  38.276,
                  38.756,
                  38.561,
                  39.322,
                  40.006,
                  40.725,
                  38.629,
                  38.812,
                  39.131,
                  38.943,
                  38.381,
                  39.605,
                  38.437,
                  37.575
                ],
                "dateArr": [
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:30:00",
                  "2024-04-02 18:20:00",
                  "2024-04-02 18:10:00",
                  "2024-04-02 18:00:00",
                  "2024-04-02 17:50:00",
                  "2024-04-02 17:40:00",
                  "2024-04-02 17:30:00",
                  "2024-04-02 17:20:00",
                  "2024-04-02 17:10:00",
                  "2024-04-02 16:40:00",
                  "2024-04-02 16:20:00",
                  "2024-04-02 16:00:00",
                  "2024-04-02 15:50:00",
                  "2024-04-02 15:40:00",
                  "2024-04-02 15:30:00",
                  "2024-04-02 15:10:00",
                  "2024-04-02 15:00:00",
                  "2024-04-02 14:50:00",
                  "2024-04-02 14:40:00",
                  "2024-04-02 14:30:00",
                  "2024-04-02 14:20:00",
                  "2024-04-02 14:10:00",
                  "2024-04-02 14:00:00",
                  "2024-04-02 13:50:00",
                  "2024-04-02 13:40:00",
                  "2024-04-02 13:30:00",
                  "2024-04-02 13:20:00",
                  "2024-04-02 13:10:00",
                  "2024-04-02 13:00:00",
                  "2024-04-02 12:50:00",
                  "2024-04-02 12:40:00",
                  "2024-04-02 12:20:00",
                  "2024-04-02 12:10:00",
                  "2024-04-02 12:00:00",
                  "2024-04-02 11:50:00",
                  "2024-04-02 11:30:00",
                  "2024-04-02 11:20:00",
                  "2024-04-02 10:50:00",
                  "2024-04-02 10:40:00",
                  "2024-04-02 10:30:00",
                  "2024-04-02 10:20:00",
                  "2024-04-02 10:10:00",
                  "2024-04-02 10:00:00",
                  "2024-04-02 09:40:00",
                  "2024-04-02 09:30:00",
                  "2024-04-02 09:20:00",
                  "2024-04-02 09:10:00",
                  "2024-04-02 09:00:00",
                  "2024-04-02 08:50:00",
                  "2024-04-02 08:40:00",
                  "2024-04-02 08:30:00",
                  "2024-04-02 08:10:00",
                  "2024-04-02 08:00:00",
                  "2024-04-02 07:50:00",
                  "2024-04-02 07:40:00",
                  "2024-04-02 07:30:00",
                  "2024-04-02 07:20:00",
                  "2024-04-02 07:10:00",
                  "2024-04-02 07:00:00",
                  "2024-04-02 06:50:00",
                  "2024-04-02 06:40:00",
                  "2024-04-02 06:30:00",
                  "2024-04-02 06:20:00",
                  "2024-04-02 06:10:00",
                  "2024-04-02 06:00:00",
                  "2024-04-02 05:50:00",
                  "2024-04-02 05:40:00",
                  "2024-04-02 05:30:00",
                  "2024-04-02 05:20:00",
                  "2024-04-02 05:10:00",
                  "2024-04-02 05:00:00",
                  "2024-04-02 04:50:00",
                  "2024-04-02 04:40:00",
                  "2024-04-02 04:30:00",
                  "2024-04-02 04:20:00",
                  "2024-04-02 04:10:00",
                  "2024-04-02 04:00:00",
                  "2024-04-02 03:50:00",
                  "2024-04-02 03:40:00",
                  "2024-04-02 03:30:00",
                  "2024-04-02 03:20:00",
                  "2024-04-02 03:10:00",
                  "2024-04-02 03:00:00",
                  "2024-04-02 02:50:00",
                  "2024-04-02 02:40:00",
                  "2024-04-02 02:30:00",
                  "2024-04-02 02:20:00",
                  "2024-04-02 02:10:00",
                  "2024-04-02 02:00:00",
                  "2024-04-02 01:50:00",
                  "2024-04-02 01:40:00",
                  "2024-04-02 01:30:00",
                  "2024-04-02 01:00:00",
                  "2024-04-02 00:50:00",
                  "2024-04-02 00:40:00",
                  "2024-04-02 00:30:00",
                  "2024-04-02 00:20:00",
                  "2024-04-02 00:10:00",
                  "2024-04-02 00:00:00"
                ],
                "rtdArr": [],
                "avgArr": [
                  38.593,
                  38.509,
                  38.518,
                  38.486,
                  38.67,
                  38.324,
                  38.558,
                  39.488,
                  39.285,
                  38.555,
                  39.746,
                  38.398,
                  39.8,
                  40.08,
                  40.205,
                  40.225,
                  39.915,
                  39.729,
                  40.121,
                  40.193,
                  40.181,
                  40.207,
                  40.159,
                  39.856,
                  39.709,
                  39.52,
                  39.137,
                  39.129,
                  39.108,
                  39.098,
                  39.04,
                  39.174,
                  38.994,
                  39.029,
                  38.963,
                  38.737,
                  37.237,
                  37.792,
                  38.692,
                  37.661,
                  37.717,
                  38.076,
                  37.442,
                  36.602,
                  38.206,
                  38.334,
                  38.882,
                  40.031,
                  40.465,
                  40.686,
                  40.377,
                  40.542,
                  40.003,
                  39.958,
                  39.969,
                  40.277,
                  39.958,
                  40.247,
                  40.447,
                  40.841,
                  41.806,
                  41.689,
                  37.957,
                  37.975,
                  36.882,
                  39.207,
                  38.637,
                  38.988,
                  38.236,
                  41.414,
                  37.472,
                  39.086,
                  38.529,
                  38.983,
                  40.113,
                  39.904,
                  39.815,
                  40.455,
                  40.315,
                  40.95,
                  33.509,
                  39.241,
                  41.794,
                  39.002,
                  40.274,
                  39.68,
                  39.062,
                  40.434,
                  39.548,
                  40.532,
                  40.407,
                  41.254,
                  38.88,
                  38.865,
                  39.587,
                  39.523,
                  39.515,
                  39.701,
                  39.442,
                  37.886
                ],
                "deviceId": "230911XF02",
                "deviceName": "水厂末梢水水质",
                "deviceLocation": "哈尔莫顿镇末梢水"
              };
            } else if (arg == 7) {
              this.minuteRecod = {
                "maxArr": [
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1
                ],
                "minArr": [
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1
                ],
                "dateArr": [
                  "2024-04-02 19:00:00",
                  "2024-04-02 19:00:00",
                  "2024-04-02 19:00:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:30:00",
                  "2024-04-02 18:20:00",
                  "2024-04-02 18:10:00",
                  "2024-04-02 18:00:00",
                  "2024-04-02 17:50:00",
                  "2024-04-02 17:40:00",
                  "2024-04-02 17:30:00",
                  "2024-04-02 17:20:00",
                  "2024-04-02 17:10:00",
                  "2024-04-02 16:40:00",
                  "2024-04-02 16:20:00",
                  "2024-04-02 16:00:00",
                  "2024-04-02 15:50:00",
                  "2024-04-02 15:40:00",
                  "2024-04-02 15:30:00",
                  "2024-04-02 15:10:00",
                  "2024-04-02 15:00:00",
                  "2024-04-02 14:50:00",
                  "2024-04-02 14:40:00",
                  "2024-04-02 14:30:00",
                  "2024-04-02 14:20:00",
                  "2024-04-02 14:10:00",
                  "2024-04-02 14:00:00",
                  "2024-04-02 13:50:00",
                  "2024-04-02 13:40:00",
                  "2024-04-02 13:30:00",
                  "2024-04-02 13:20:00",
                  "2024-04-02 13:10:00",
                  "2024-04-02 13:00:00",
                  "2024-04-02 12:50:00",
                  "2024-04-02 12:40:00",
                  "2024-04-02 12:20:00",
                  "2024-04-02 12:10:00",
                  "2024-04-02 12:00:00",
                  "2024-04-02 11:50:00",
                  "2024-04-02 11:30:00",
                  "2024-04-02 11:20:00",
                  "2024-04-02 10:50:00",
                  "2024-04-02 10:40:00",
                  "2024-04-02 10:30:00",
                  "2024-04-02 10:20:00",
                  "2024-04-02 10:10:00",
                  "2024-04-02 10:00:00",
                  "2024-04-02 09:40:00",
                  "2024-04-02 09:30:00",
                  "2024-04-02 09:20:00",
                  "2024-04-02 09:10:00",
                  "2024-04-02 09:00:00",
                  "2024-04-02 08:50:00",
                  "2024-04-02 08:40:00",
                  "2024-04-02 08:30:00",
                  "2024-04-02 08:10:00",
                  "2024-04-02 08:00:00",
                  "2024-04-02 07:50:00",
                  "2024-04-02 07:40:00",
                  "2024-04-02 07:30:00",
                  "2024-04-02 07:20:00",
                  "2024-04-02 07:10:00",
                  "2024-04-02 07:00:00",
                  "2024-04-02 06:50:00",
                  "2024-04-02 06:40:00",
                  "2024-04-02 06:30:00",
                  "2024-04-02 06:20:00",
                  "2024-04-02 06:10:00",
                  "2024-04-02 06:00:00",
                  "2024-04-02 05:50:00",
                  "2024-04-02 05:40:00",
                  "2024-04-02 05:30:00",
                  "2024-04-02 05:20:00",
                  "2024-04-02 05:10:00",
                  "2024-04-02 05:00:00",
                  "2024-04-02 04:50:00",
                  "2024-04-02 04:40:00",
                  "2024-04-02 04:30:00",
                  "2024-04-02 04:20:00",
                  "2024-04-02 04:10:00",
                  "2024-04-02 04:00:00",
                  "2024-04-02 03:50:00",
                  "2024-04-02 03:40:00",
                  "2024-04-02 03:30:00",
                  "2024-04-02 03:20:00",
                  "2024-04-02 03:10:00",
                  "2024-04-02 03:00:00",
                  "2024-04-02 02:50:00",
                  "2024-04-02 02:40:00",
                  "2024-04-02 02:30:00",
                  "2024-04-02 02:20:00",
                  "2024-04-02 02:10:00",
                  "2024-04-02 02:00:00",
                  "2024-04-02 01:50:00",
                  "2024-04-02 01:40:00",
                  "2024-04-02 01:30:00",
                  "2024-04-02 01:00:00",
                  "2024-04-02 00:50:00",
                  "2024-04-02 00:40:00",
                  "2024-04-02 00:30:00",
                  "2024-04-02 00:20:00",
                  "2024-04-02 00:10:00",
                  "2024-04-02 00:00:00"
                ],
                "rtdArr": [],
                "avgArr": [
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1,
                  0.1
                ],
                "deviceId": "230911XF02",
                "deviceName": "水厂末梢水水质",
                "deviceLocation": "哈尔莫顿镇末梢水"
              };
            } else if (arg == 8) {
              this.minuteRecod = {
                "maxArr": [
                  645.599,
                  648.229,
                  646.654,
                  646.0,
                  645.714,
                  646.561,
                  645.217,
                  644.652,
                  644.866,
                  645.446,
                  645.246,
                  644.92,
                  644.715,
                  645.41,
                  645.882,
                  644.039,
                  644.282,
                  643.563,
                  643.938,
                  643.176,
                  645.279,
                  645.821,
                  645.301,
                  642.591,
                  644.194,
                  645.082,
                  646.244,
                  644.117,
                  643.431,
                  644.516,
                  643.87,
                  646.569,
                  643.794,
                  644.826,
                  646.076,
                  643.917,
                  645.047,
                  643.917,
                  645.051,
                  645.149,
                  643.428,
                  645.966,
                  645.332,
                  643.149,
                  645.597,
                  646.063,
                  645.684,
                  644.991,
                  645.233,
                  645.572,
                  646.633,
                  645.126,
                  646.283,
                  646.455,
                  645.786,
                  646.737,
                  645.959,
                  646.399,
                  644.928,
                  645.178,
                  645.857,
                  645.723,
                  645.136,
                  643.963,
                  643.496,
                  644.198,
                  642.791,
                  644.63,
                  644.837,
                  643.933,
                  643.088,
                  645.2,
                  646.634,
                  644.34,
                  644.125,
                  643.719,
                  644.619,
                  643.788,
                  645.719,
                  645.412,
                  645.831,
                  645.539,
                  644.685,
                  646.212,
                  645.571,
                  645.493,
                  645.843,
                  646.852,
                  646.854,
                  644.383,
                  645.655,
                  644.103,
                  645.813,
                  644.883,
                  642.626,
                  641.119,
                  642.968,
                  641.466,
                  641.655,
                  640.07,
                  641.299
                ],
                "minArr": [
                  645.026,
                  647.551,
                  645.733,
                  645.324,
                  645.454,
                  645.806,
                  645.04,
                  644.087,
                  644.362,
                  645.25,
                  644.989,
                  644.121,
                  644.405,
                  643.836,
                  643.498,
                  643.361,
                  643.767,
                  643.054,
                  643.912,
                  642.514,
                  642.551,
                  641.905,
                  644.743,
                  642.374,
                  642.252,
                  643.003,
                  643.136,
                  643.216,
                  643.062,
                  642.819,
                  643.541,
                  643.99,
                  643.585,
                  644.181,
                  644.169,
                  642.974,
                  643.086,
                  643.344,
                  644.275,
                  643.806,
                  643.212,
                  644.245,
                  644.088,
                  642.583,
                  644.436,
                  644.886,
                  643.788,
                  644.814,
                  643.211,
                  644.568,
                  643.812,
                  645.056,
                  643.147,
                  645.476,
                  645.289,
                  646.528,
                  644.67,
                  646.116,
                  643.982,
                  643.74,
                  645.448,
                  643.783,
                  643.766,
                  643.739,
                  643.238,
                  643.375,
                  642.736,
                  642.439,
                  644.166,
                  642.853,
                  642.937,
                  643.491,
                  644.365,
                  643.513,
                  643.739,
                  642.723,
                  644.037,
                  643.69,
                  645.292,
                  643.9,
                  644.292,
                  644.29,
                  642.709,
                  645.603,
                  645.476,
                  644.581,
                  644.5,
                  643.928,
                  644.911,
                  643.57,
                  644.326,
                  643.711,
                  643.614,
                  643.187,
                  640.768,
                  641.019,
                  640.898,
                  641.425,
                  641.274,
                  639.958,
                  641.14
                ],
                "dateArr": [
                  "2024-04-02 19:00:00",
                  "2024-04-02 19:00:00",
                  "2024-04-02 19:00:00",
                  "2024-04-02 18:40:00",
                  "2024-04-02 18:30:00",
                  "2024-04-02 18:20:00",
                  "2024-04-02 18:10:00",
                  "2024-04-02 18:00:00",
                  "2024-04-02 17:50:00",
                  "2024-04-02 17:40:00",
                  "2024-04-02 17:30:00",
                  "2024-04-02 17:20:00",
                  "2024-04-02 17:10:00",
                  "2024-04-02 16:40:00",
                  "2024-04-02 16:20:00",
                  "2024-04-02 16:00:00",
                  "2024-04-02 15:50:00",
                  "2024-04-02 15:40:00",
                  "2024-04-02 15:30:00",
                  "2024-04-02 15:10:00",
                  "2024-04-02 15:00:00",
                  "2024-04-02 14:50:00",
                  "2024-04-02 14:40:00",
                  "2024-04-02 14:30:00",
                  "2024-04-02 14:20:00",
                  "2024-04-02 14:10:00",
                  "2024-04-02 14:00:00",
                  "2024-04-02 13:50:00",
                  "2024-04-02 13:40:00",
                  "2024-04-02 13:30:00",
                  "2024-04-02 13:20:00",
                  "2024-04-02 13:10:00",
                  "2024-04-02 13:00:00",
                  "2024-04-02 12:50:00",
                  "2024-04-02 12:40:00",
                  "2024-04-02 12:20:00",
                  "2024-04-02 12:10:00",
                  "2024-04-02 12:00:00",
                  "2024-04-02 11:50:00",
                  "2024-04-02 11:30:00",
                  "2024-04-02 11:20:00",
                  "2024-04-02 10:50:00",
                  "2024-04-02 10:40:00",
                  "2024-04-02 10:30:00",
                  "2024-04-02 10:20:00",
                  "2024-04-02 10:10:00",
                  "2024-04-02 10:00:00",
                  "2024-04-02 09:40:00",
                  "2024-04-02 09:30:00",
                  "2024-04-02 09:20:00",
                  "2024-04-02 09:10:00",
                  "2024-04-02 09:00:00",
                  "2024-04-02 08:50:00",
                  "2024-04-02 08:40:00",
                  "2024-04-02 08:30:00",
                  "2024-04-02 08:10:00",
                  "2024-04-02 08:00:00",
                  "2024-04-02 07:50:00",
                  "2024-04-02 07:40:00",
                  "2024-04-02 07:30:00",
                  "2024-04-02 07:20:00",
                  "2024-04-02 07:10:00",
                  "2024-04-02 07:00:00",
                  "2024-04-02 06:50:00",
                  "2024-04-02 06:40:00",
                  "2024-04-02 06:30:00",
                  "2024-04-02 06:20:00",
                  "2024-04-02 06:10:00",
                  "2024-04-02 06:00:00",
                  "2024-04-02 05:50:00",
                  "2024-04-02 05:40:00",
                  "2024-04-02 05:30:00",
                  "2024-04-02 05:20:00",
                  "2024-04-02 05:10:00",
                  "2024-04-02 05:00:00",
                  "2024-04-02 04:50:00",
                  "2024-04-02 04:40:00",
                  "2024-04-02 04:30:00",
                  "2024-04-02 04:20:00",
                  "2024-04-02 04:10:00",
                  "2024-04-02 04:00:00",
                  "2024-04-02 03:50:00",
                  "2024-04-02 03:40:00",
                  "2024-04-02 03:30:00",
                  "2024-04-02 03:20:00",
                  "2024-04-02 03:10:00",
                  "2024-04-02 03:00:00",
                  "2024-04-02 02:50:00",
                  "2024-04-02 02:40:00",
                  "2024-04-02 02:30:00",
                  "2024-04-02 02:20:00",
                  "2024-04-02 02:10:00",
                  "2024-04-02 02:00:00",
                  "2024-04-02 01:50:00",
                  "2024-04-02 01:40:00",
                  "2024-04-02 01:30:00",
                  "2024-04-02 01:00:00",
                  "2024-04-02 00:50:00",
                  "2024-04-02 00:40:00",
                  "2024-04-02 00:30:00",
                  "2024-04-02 00:20:00",
                  "2024-04-02 00:10:00",
                  "2024-04-02 00:00:00"
                ],
                "rtdArr": [],
                "avgArr": [
                  645.312,
                  647.89,
                  646.193,
                  645.662,
                  645.584,
                  646.184,
                  645.129,
                  644.369,
                  644.614,
                  645.348,
                  645.118,
                  644.521,
                  644.56,
                  644.623,
                  644.69,
                  643.7,
                  644.024,
                  643.308,
                  643.925,
                  642.845,
                  643.915,
                  643.863,
                  645.022,
                  642.483,
                  643.223,
                  644.042,
                  644.69,
                  643.667,
                  643.247,
                  643.668,
                  643.705,
                  645.28,
                  643.689,
                  644.503,
                  645.123,
                  643.445,
                  644.066,
                  643.63,
                  644.663,
                  644.478,
                  643.32,
                  645.106,
                  644.71,
                  642.866,
                  645.017,
                  645.475,
                  644.736,
                  644.903,
                  644.222,
                  645.07,
                  645.223,
                  645.091,
                  644.715,
                  645.965,
                  645.538,
                  646.633,
                  645.315,
                  646.257,
                  644.455,
                  644.459,
                  645.652,
                  644.753,
                  644.451,
                  643.851,
                  643.367,
                  643.787,
                  642.763,
                  643.535,
                  644.502,
                  643.393,
                  643.013,
                  644.345,
                  645.5,
                  643.926,
                  643.932,
                  643.221,
                  644.328,
                  643.739,
                  645.505,
                  644.656,
                  645.062,
                  644.915,
                  643.697,
                  645.908,
                  645.524,
                  645.037,
                  645.171,
                  645.39,
                  645.883,
                  643.977,
                  644.991,
                  643.907,
                  644.714,
                  644.035,
                  641.697,
                  641.069,
                  641.933,
                  641.446,
                  641.465,
                  640.014,
                  641.219
                ],
                "deviceId": "230911XF02",
                "deviceName": "水厂末梢水水质",
                "deviceLocation": "哈尔莫顿镇末梢水"
              };
            }
            this.setOptionNew(arg);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
        })
      },
      setLineMax(heightLinevalue, data) {
        var max = Math.max.apply(Math, data);
        if (heightLinevalue === null || heightLinevalue === "") {} else if (heightLinevalue > max) {
          max = heightLinevalue;
        }
        return max
      },
      setLineMin(lowLinevalue, data) {
        var min = Math.min.apply(Math, data);
        if (lowLinevalue === null || lowLinevalue === "") {} else if (lowLinevalue < min) {
          min = lowLinevalue;
        }
        return min
      },
      setOption(arg = 1) {
        let lineData = this.FlowLineStatistical[arg]
        let seriesData = []
        let category = [this.$t('酸碱度'), this.$t('温度'), this.$t('浊度'), this.$t('余氯'), this.$t('溶解氧'), this.$t('氧化还原'), this.$t('电导率'), this.$t('氨氮'), this.$t('化学耗氧量'), this.$t('高锰酸盐')]
        let unitList = ['PH', '℃', 'NTU', 'mg/L', 'mg/L', 'mV', 'mS/cm', 'mg/L', 'mg/L', 'mg/L'];
        let name = category[arg - 1]
        let indicator = ['ph', 'temp', 'ss', 'fcl', 'doo', 'orp', 'ec', 'nh3n', 'chemo', 'perm']
        this.lowValue = this.standard[indicator[arg - 1] + '_down']
        this.heightValue = this.standard[indicator[arg - 1] + '_up']
        let max = this.setLineMax(this.heightValue, lineData)
        let min = this.setLineMin(this.lowValue, lineData)
        let lowValue = this.lowValue
        let heightValue = this.heightValue
        let xAxisData = []
        for (let i = 0; i < this.FlowLineStatistical[0].length; i++) {
          xAxisData.push(((this.FlowLineStatistical[0][i] + '').padStart(2, '0')))
        }
        this.option = {
          color: ['#FECA20', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0', '#F7B500',
            '#FA6400', '#E02020'
          ],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          legend: {
            show: false,
            data: category,
            textStyle: {
              color: '#CEE2FF'
            },
            icon: 'circle'
          },
          grid: {
            x: '10',
            y: '30',
            x2: '30',
            y2: '10',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xAxisData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#2A6BAC',
              fontSize: 10
            }
          },
          yAxis: {
            type: 'value',
            name: unitList[arg - 1],
            nameTextStyle: {
              color: '#2A6BAC',
              align: 'right',
            },
            animationDuration: 2000,
            splitLine: {
              show: true,
              lineStyle: {
                color: '#2A4D7B',
                opacity: 0.54
              }
            },
            max: max,
            min: min,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#2A6BAC',
              fontSize: 10
            }
          },
          visualMap: {
            show: false,
            dimension: 1,
            pieces: [{
                gte: heightValue,
                color: 'red'
              },
              {
                lte: lowValue,
                color: 'red'
              }
            ],
            outOfRange: {
              color: '#0091FF'
            }
          },
          series: {

            name: name,
            type: 'line',
            smooth: false,
            symbol: "none",
            animationDelay: 100,
            animationDuration: 2000,
            lineStyle: {
              width: 3,
              //shadowColor: 'rgba(255,0,0,0.8)',
              shadowColor: '#9bfeff',
              //shadowBlur: 20,
              //shadowOffsetY: 40
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#019AF3'
              }, {
                offset: 0.3,
                color: 'rgba(0, 145, 255,.0)'
              }, {
                offset: 1,
                color: 'rgba(0, 145, 255,.0)'
              }])
            },
            markLine: {
              animationDelay: 1000,
              animationDuration: 2000,
              symbol: ['none', 'arrow'],
              silent: true,
              lineStyle: {
                normal: {
                  color: 'red',
                  type: 'dotted',
                  //这儿设置安全基线颜色
                }
              },
              data: [{
                  name: this.$t('低位告警线'),
                  type: 'min',
                  yAxis: lowValue,
                  lineStyle: {
                    color: 'orange'
                  }
                },
                {
                  name: this.$t('高位告警线'),
                  type: 'max',
                  yAxis: heightValue,
                  lineStyle: {
                    color: 'red'
                  }
                }
              ]
            },
            data: lineData
          }
        };
      },
      setOptionNew(arg) {
        let lineData = this.minuteRecod.avgArr
        if (this.minuteRecod.rtdArr.length > 0) {
          lineData = this.minuteRecod.rtdArr
        }
        let seriesData = []
        let category = [this.$t('酸碱度'), this.$t('色度'), this.$t('浊度') /*,'溶解性总固体'*/ , this.$t('硬度'), this.$t('氧化还原'), this.$t('氯化物') /*,'硫酸盐','高锰酸盐'*/ , this.$t('温度值'), this.$t('余氯'), this.$t('电导率')]
        let unitList = ['PH', this.$t('度'), 'NTU', 'mg/L', 'mg/L', 'mV', 'mg/L', 'mg/L', 'mg/L'];
        let name = category[arg]
        let indicator = ['w01001', 'w01002', 'w01003' /*,'w01006'*/ , 'w10000', 'w10001',
          'w21022' /*,'w21038','w01019'*/ , 'w01010', 'w21024', 'w01014'
        ]
        // let remark = JSON.parse(this.dataSource[0].remark)
        // this.lowValue = remark[indicator[arg] + '_down']
        // this.heightValue = remark[indicator[arg] + '_up']
        if(this.waterQualityMeter.remark) {
            let remark = JSON.parse(this.waterQualityMeter.remark)
            this.lowValue = remark[indicator[arg]+'_down']
            this.heightValue = remark[indicator[arg]+'_up']
        }else{
            this.lowValue = null
            this.heightValue = null
        }
        let max = this.setLineMax(this.heightValue, lineData)
        let min = this.setLineMin(this.lowValue, lineData)
        let lowValue = this.lowValue
        let heightValue = this.heightValue
        console.log(indicator[arg])
        console.log(lowValue, heightValue, min, max)
        let xAxisData = []
        for (let i = 0; i < this.minuteRecod.dateArr.length; i++) {
          xAxisData.push(((this.minuteRecod.dateArr[i] + '').substring(11)))
        }

        let option = {
          color: ['#019AF3', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0', '#F7B500',
            '#FA6400', '#E02020'
          ],
          title: {
            show: false
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          legend: {
            show: false,
            data: category,
            textStyle: {
              color: '#CEE2FF'
            },
            icon: 'circle'
          },
          grid: {
            x: '10',
            y: '30',
            x2: '30',
            y2: '10',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: xAxisData,
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#CEE2FF',
              fontSize: 10
            }
          },
          yAxis: {
            type: 'value',
            name: unitList[arg],
            nameTextStyle: {
              color: '#2A6BAC',
              align: 'right',
            },
            animationDuration: 2000,
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dotted',
                color: ['#074671'],
              }
            },
            max: max,
            //min: 0,
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#D1F3FF',
              fontSize: 10
            }
          },
          series: {

            name: name,
            type: 'line',
            smooth: false,
            symbol: "none",
            animationDelay: 100,
            animationDuration: 2000,
            lineStyle: {
              width: 3,
              //shadowColor: 'rgba(255,0,0,0.8)',
              shadowColor: '#9bfeff',
              //shadowBlur: 20,
              //shadowOffsetY: 40
            },
            // areaStyle: {
            //     color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            //         offset: 0,
            //         color: '#019AF3'
            //     },{
            //         offset: 0.3,
            //         color: 'rgba(0, 145, 255,.0)'
            //     },{
            //         offset: 1,
            //         color: 'rgba(0, 145, 255,.0)'
            //     }
            //     ])
            // },

            data: lineData
          }
        };
        let markLine = []
        let visualMapPieces = []
        if (!isUndefinedAndNull(lowValue)) {
          markLine.push({
            name: this.$t('低位告警线'),
            type: 'min',
            yAxis: lowValue,
            lineStyle: {
              color: 'orange'
            }
          })
          visualMapPieces.push({
            lte: lowValue,
            color: 'red'
          })
        }
        if (!isUndefinedAndNull(heightValue)) {
          markLine.push({
            name: this.$t('高位告警线'),
            type: 'max',
            yAxis: heightValue,
            lineStyle: {
              color: 'red'
            }
          })
          visualMapPieces.push({
            gte: heightValue,
            color: 'red'
          })
        }
        if (visualMapPieces.length > 0) {
          let visualMapData = {
            show: false,
            dimension: 1,
            pieces: visualMapPieces,
            outOfRange: {
              color: '#0091FF'
            },
            inRange: {
              color: ['#fff', '#b8ddf0', '#e0bdb8', '#e16f56', '#EB190A', ]
            },
          }
          // 当data的值太小时，区域显示为黑色的问题暂未解决
          //option.visualMap = visualMapData
        }
        console.log(visualMapPieces)
        console.log(markLine)
        if (markLine.length > 0) {
          option.series.markLine = {
            animationDelay: 1000,
            animationDuration: 2000,
            symbol: ['none', 'arrow'],
            silent: true,
            lineStyle: {
              normal: {
                color: 'red',
                type: 'dotted',
                //这儿设置安全基线颜色
              }
            },
            data: markLine
          }
        }
        this.option = option
      }
    }
  }
</script>
<style scoped>
  .tabs {
    display: flex;
    justify-content: flex-end;
    /* margin-left: 41px; */
  }

  .tab {
    padding: 4px 6px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .waterQualitySelect {
    color: rgb(0, 250, 254);
  }

  .waterQualitySelect /deep/ .ant-select-selection {
    background: none;
    border: 1px solid rgb(0, 250, 254);
  }
</style>